import { Component } from "react"
import DataTable from "react-data-table-component"
import ContentContainer from "../../../containers/UI/ContentContainer/ContentContainer"
import axios from "../../../axios"
import classes from "./downloads.css"
import EntryModal from "./EntryModal/EntryModal"

class Customers extends Component {

  state = {

    // Overview
    downloads: [],

    // Modal
    showModal: false,
    createMode: false,
    selectedEntry: {}
  }

  // Constants

  pageTitle = {
    "router": "KNX IoT Router",
    "lora-gateway": "LoRa Gateway"
  }

  columns = [
    { name: "Page", selector: "page", grow: 1, sortable: true, left: true, style: { fontSize: "15px", textTransform: "capitalize" }, format: (row) => this.pageTitle[row.page] ?? row.page,  sortFunction: (a, b) => b.page.localeCompare(a.page) || b.position - a.position  },
    { name: "Name", selector: "name", grow: 3, sortable: true, style: { fontSize: "14px" }},
    { name: "Last updated", selector: "lastUpdated", grow: 1, sortable: true, right: true, style: { fontSize: "13px" }},
  ]

  // MARK: - Initialization

  componentDidMount() {

    this.fetchDownloads()
  }

  fetchDownloads = () => {

    axios.get("/downloads/all").then(response => {
      if (response.data) {
        this.setState({ downloads: response.data })
      }
    })
  }


  // MARK: - Handlers

  addDownloadHandler = () => {

    // Add new entry to the list
    let entry = { page: "", name: "", lastUpdated: "", filename: "" }
    let downloads = [...this.state.downloads, entry]

    // Update state and show modal
    this.setState({ downloads, selectedEntry: entry, showModal: true, createMode: true })
  }

  displayModal = (shouldBeShown, software) => {

    // Present the modal
    this.setState({ showModal: shouldBeShown, selectedEntry: software, createMode: false })
  }

  closeModalHandler = () => {

    // Stop showing
    this.displayModal(false, {})

    // Refresh the list
    this.fetchDownloads()
  }

  render() {
    return (
      <ContentContainer title="Download pages">
        <div className={classes.header}>
          <h2 className={classes.headerTitle}>Entries</h2>
          <button onClick={this.addDownloadHandler} className={classes.addButton}>Add download</button>
        </div>
        <DataTable
          columns={this.columns}
          data={this.state.downloads}
          noHeader={true}
          pagination={true}
          highlightOnHover={true}
          striped={true}
          defaultSortField={"page"}
          defaultSortAsc={false}
          customStyles={{
            headCells: { style: { fontWeight: "bold", fontSize: "15px" }}
          }}
          onRowClicked={(software) => this.displayModal(true, software)}
        />


        {this.state.showModal &&
          <EntryModal
            createMode={this.state.createMode}
            shouldShow={this.state.showModal}
            download={this.state.selectedEntry}
            closeModal={() => this.closeModalHandler()}
          />
        }
      </ContentContainer>
    );
  }
}

export default Customers;
